module.exports = __webpack_public_path__ + "img/bf4de8d42468537b151d4d283cecb317.png";